import React from 'react';
import { ChartColumn } from 'lucide-react';

interface SalaryRow {
  position: string;
  junior: string;
  mid: string;
  senior: string;
  lead: string;
}

interface SalaryTableProps {
  title: string;
  rows: SalaryRow[];
  note?: string;
}

// Hilfsfunktion: Wandelt normale Leerzeichen in geschützte Leerzeichen um
const formatSalary = (value: string): string => {
  return value
    // sichere Abstände um Bindestrich/En-Dash
    .replace(/\s*[-–]\s*/g, '\u00A0-\u00A0')
    // geschütztes Leerzeichen vor dem Euro-Zeichen
    .replace(/\s*€/g, '\u00A0€')
    // evtl. vorhandene Zahlengruppen-Trennungen mit geschützten Leerzeichen fixen (z. B. "120 000")
    .replace(/(\d)\s(?=\d{3}\b)/g, '$1\u00A0');
};

const SalaryTable: React.FC<SalaryTableProps> = ({ title, rows, note }) => {
  return (
    <div className="salary-overview">
      <h3 className="flex items-start gap-2.5">
        <ChartColumn className="mt-1 size-5 shrink-0" aria-hidden="true" />
        <span>{title}</span>
      </h3>
      <div className="overflow-x-auto">
        <table>
          <thead>
            <tr>
              <th>Position</th>
              <th>Junior (0-2 Jahre)</th>
              <th>Mid-Level (3-5 Jahre)</th>
              <th>Senior (6-10 Jahre)</th>
              <th>Lead/Principal</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td><strong>{row.position}</strong></td>
                <td><span className="nowrap">{formatSalary(row.junior)}</span></td>
                <td><span className="nowrap">{formatSalary(row.mid)}</span></td>
                <td><span className="nowrap">{formatSalary(row.senior)}</span></td>
                <td><span className="nowrap">{formatSalary(row.lead)}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {note && <p className="note"><em>{note}</em></p>}
    </div>
  );
};

export default SalaryTable;